// extracted by mini-css-extract-plugin
export var borderRadius = "_4y-4";
export var large = "_4y-3";
export var logoContainer = "_4y-0";
export var nameLogo = "_4y-2";
export var small = "_4y-1";